import BPKeyboardShortcut from 'components/BionicUI/keyboardShortcut/BPKeyboardShortcut';
import { cn } from 'lib/utils';
import { FC, ReactNode } from 'react';
import { Key } from 'ts-key-enum';

interface ShortcutsBarProps {
  handleClose: () => void;
}

const ShortcutsBar: FC<ShortcutsBarProps> = ({ handleClose }) => (
  <div className="grid relative w-full grid-cols-[auto_1fr_auto] gap-4 px-[18px] py-[15px] border-t border-[#ffffff30] text-[12px]">
    <div />
    <div />
    <Shortcut close={handleClose}>
      <BPKeyboardShortcut shortcutKey={Key.Escape} callback={handleClose} />
      <div>Close</div>
    </Shortcut>
  </div>
);

const Shortcut: FC<{ children: ReactNode; close?: () => void }> = ({
  children,
  close = null,
}) => (
  <div
    className={cn(
      'grid relative grid-cols-[auto_1fr] gap-2 justify-end items-center leading-none',
      close ? 'cursor-pointer' : 'cursor-default'
    )}
    onClick={close ? close : undefined}
  >
    {children}
  </div>
);

export default ShortcutsBar;
